import {defineStore} from 'pinia';
import {computed} from 'vue';
import {useSubDomain} from '@/shared/composables/useSubdomain';
import {useAuthorizationSettingsQuery} from '@/api/queries/queries/useAuthenticationSettingsQuery';

export const useAuthenticationSettings = defineStore('authenticationSettings', () => {
    const {subDomain} = useSubDomain();

    const {
        data: authenticationSettings,
        isFetching: authenticationSettingsLoading,
        refetch: reloadAuthenticationSettings,
        suspense: ensureAuthenticationSettingsLoaded,
    } = useAuthorizationSettingsQuery(subDomain);

    /**
     * Whether OIDC is enabled for the current account.
     */
    const openIdConnectEnabled = computed(
        () => !!authenticationSettings.value?.openIdConnectEnabled
    );

    return {
        authenticationSettings,
        openIdConnectEnabled,
        authenticationSettingsLoading,
        ensureAuthenticationSettingsLoaded,
        reloadAuthenticationSettings,
    };
});
